import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    sliderRoot: 'relative flex h-6 w-full touch-none items-center select-none',
    track: 'bg-system-gray-500 relative h-0.5 w-full grow',
    range: 'bg-bg-items-black absolute h-full',
    thumb:
      'flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-white focus:outline-none',
    thumbCircle: 'border-main block h-5 w-5 rounded-full border-2',
    labels: 'mb-3.5 flex justify-between',
    label: 'text-bg-items-black text-sm font-light'
  },
  variants: {
    disabled: {
      true: {
        base: 'cursor-not-allowed opacity-50',
        thumb: 'cursor-not-allowed'
      }
    }
  }
});
